"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsonSchema_json_1 = __importDefault(require("./jsonSchema.json"));
var ajv_1 = __importDefault(require("ajv"));
var ajv = new ajv_1.default();
for (var _i = 0, _a = Object.entries(jsonSchema_json_1.default.definitions); _i < _a.length; _i++) {
    var _b = _a[_i], typeName = _b[0], schema = _b[1];
    ajv.addSchema(schema, typeName);
}
var validate = function (typeName, data) {
    var valid = ajv.validate(typeName, data);
    return valid || ajv.errors;
};
exports.validate = validate;
var getSchema = function (typeName) {
    var compiledSchema = ajv.getSchema(typeName);
    if (compiledSchema)
        return compiledSchema.schema;
    return null;
};
exports.getSchema = getSchema;
